import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
	name: 'loading',
	initialState: {
		message: '',
		isLoading: false
	},
	reducers: {
		setLoading: (state, action) => {
			state.message = action.payload.message || 'Loading...';
			state.isLoading = action.payload.isLoading;
		}
	}
});
export const { setLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
